"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var createFactory = function createFactory(Type) {
  return _react.createElement.bind(null, Type);
};

var _default = createFactory;
exports.default = _default;